import React, {
    createContext,
    useContext,
    useState,
    useCallback,
    useMemo,
    useEffect,
} from "react";

interface UploadContextType {
    isUploading: boolean;
    setIsUploading: (uploading: boolean) => void;
}

const UploadContext = createContext<UploadContextType | undefined>(undefined);

export const UploadProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const [isUploading, setIsUploading] = useState(false);

    const handleSetIsUploading = useCallback((uploading: boolean) => {
        setIsUploading(uploading);
    }, []);

    // AIDEV-NOTE: Memoize context value to prevent unnecessary re-renders
    const value = useMemo(
        () => ({
            isUploading,
            setIsUploading: handleSetIsUploading,
        }),
        [isUploading, handleSetIsUploading],
    );

    return (
        <UploadContext.Provider value={value}>
            {children}
        </UploadContext.Provider>
    );
};

export const useUploadContext = () => {
    const context = useContext(UploadContext);
    if (!context) {
        throw new Error(
            "useUploadContext must be used within an UploadProvider",
        );
    }
    return context;
};
